import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Menu = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g>
        <path d="M23 13H1a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2z" />
        <path d="M23 6H1a.945.945 0 0 1-1-1 .945.945 0 0 1 1-1h22a.945.945 0 0 1 1 1 .945.945 0 0 1-1 1z" />
        <path d="M23 20H1a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2z" />
      </g>
    </svg>
  );
};

Menu.displayName = 'Menu';
